import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DatePickerSingleDate } from '@elliemae/ds-date-picker';
import DSPopper, { PopperPositions } from '@elliemae/ds-basic/Popper';
import DatePickerIcon from '@elliemae/ds-icons/DatePicker2';
import DSButton from '@elliemae/ds-basic/Button';
import moment from 'moment';
import { DEFAULT_DATE_FORMAT } from './defaultDateFormat.js';

var SingleDatePickerContainer = function SingleDatePickerContainer(_ref) {
  var _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      showHeader = _ref.showHeader;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      date = _useState2[0],
      setDate = _useState2[1];

  var handleDateChange = useCallback(function (data) {
    onChange(moment(data));
    setDate(data);
  }, []);
  return /*#__PURE__*/React.createElement(DatePickerSingleDate, {
    date: date,
    onChange: handleDateChange,
    showHeader: showHeader
  });
};

SingleDatePickerContainer.propTypes = {
  onChange: PropTypes.func,
  showHeader: PropTypes.bool
};

var formatDate = function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATE_FORMAT;
  return date.format(format);
};

function SingleDateFilterMenu(_ref2) {
  var column = _ref2.column,
      className = _ref2.className,
      _ref2$isMenuOpened = _ref2.isMenuOpened,
      isMenuOpened = _ref2$isMenuOpened === void 0 ? false : _ref2$isMenuOpened,
      _ref2$onOpenMenu = _ref2.onOpenMenu,
      onOpenMenu = _ref2$onOpenMenu === void 0 ? function () {
    return null;
  } : _ref2$onOpenMenu,
      _ref2$placement = _ref2.placement,
      placement = _ref2$placement === void 0 ? PopperPositions.BOTTOM_END : _ref2$placement,
      _ref2$onAddFilter = _ref2.onAddFilter,
      onAddFilter = _ref2$onAddFilter === void 0 ? function () {
    return null;
  } : _ref2$onAddFilter,
      _ref2$dateFormatter = _ref2.dateFormatter,
      dateFormatter = _ref2$dateFormatter === void 0 ? formatDate : _ref2$dateFormatter,
      _ref2$showHeader = _ref2.showHeader,
      showHeader = _ref2$showHeader === void 0 ? false : _ref2$showHeader,
      menuProps = _ref2.menuProps;
  return /*#__PURE__*/React.createElement(DSPopper, {
    contentComponent: /*#__PURE__*/React.createElement("div", {
      className: className,
      "data-testid": "date-single__wrapper"
    }, /*#__PURE__*/React.createElement(SingleDatePickerContainer, {
      minimumNights: 0,
      onChange: function onChange(date) {
        var t = date.clone();
        onAddFilter({
          group: column.property,
          label: column.label,
          value: dateFormatter(date, column.dateFormat),
          type: 'date',
          operator: 'range',
          filterParams: {
            start: date.startOf('day'),
            end: t.endOf('day')
          },
          transformRowValue: function transformRowValue(value) {
            return moment(value, column.dateFormat || DEFAULT_DATE_FORMAT);
          }
        }, column);
        onOpenMenu(false);
      },
      showHeader: showHeader
    })),
    isOpen: isMenuOpened,
    onOpen: onOpenMenu,
    placement: placement,
    showArrow: false,
    triggerComponent: /*#__PURE__*/React.createElement(DSButton, {
      buttonType: "text",
      icon: /*#__PURE__*/React.createElement(DatePickerIcon, null),
      onClick: function onClick() {
        return !isMenuOpened ? onOpenMenu(true) : onOpenMenu(false);
      },
      size: "s"
    }),
    zIndex: menuProps.zIndex
  });
}

SingleDateFilterMenu.propTypes = {
  column: PropTypes.any,
  className: PropTypes.string,
  isMenuOpened: PropTypes.bool,
  onOpenMenu: PropTypes.func,
  placement: PropTypes.string,
  onAddFilter: PropTypes.func,
  dateFormatter: PropTypes.any,
  showHeader: PropTypes.bool,
  menuProps: PropTypes.any
};

export default SingleDateFilterMenu;
//# sourceMappingURL=SingleDateFilterMenu.js.map
